import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  DeletePermissions,
  getallPermissions,
} from "../../redux/features/permissionSlice";
import {
  deleteUimodule,
  getUimodules,
} from "../../redux/features/uimoduleSlice";

const DeleteUimodule = ({ id, dispatchdata }) => {
  const { loading } = useSelector((state) => state.uimodule);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete UI module"}
      deleteNote={"Are you sure? you want to delete this module..?"}
      api={deleteUimodule(id)}
      upDateCall={getUimodules(dispatchdata)}
      loading={loading}
    />
  );
};

export default DeleteUimodule;
